import { isEmpty } from 'app/utils/objects/helpers'

// Helper function to set nested errors using dot notation
const setNestedError = (errors, path, error) => {
  const keys = path.split('.')
  let current = errors
  const forbiddenKeys = ['__proto__', 'constructor', 'prototype']

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i]
    if (forbiddenKeys.includes(key)) {
      return
    }
    if (!(key in current)) {
      current[key] = {}
    }
    current = current[key]
  }

  const lastKey = keys[keys.length - 1]
  if (forbiddenKeys.includes(lastKey)) {
    return
  }
  current[lastKey] = error
}

// this accepts fieldValidation fn
// that accepts 3 params fieldName (string), val (any), values ({[key: string]: any})
// and it returns object that contains only error fields as keys and object of errors (key is error id and value is error message string)
export const formValidationBuilder = (fieldValidation) => {
  return (values) => {
    const errors = {}

    // Helper function to recursively process all fields including nested ones
    const processFields = (obj, prefix = '') => {
      Object.entries(obj).forEach(([fieldName, val]) => {
        const fullFieldName = prefix ? `${prefix}.${fieldName}` : fieldName

        // Validate the current field
        const fieldValidationResult = fieldValidation(
          fullFieldName,
          val,
          values,
        )

        if (fieldValidationResult) {
          // Filter out non-error messages (empty messages)
          const fieldErrors = Object.entries(fieldValidationResult).reduce(
            (accErrors, [key, errorString]) => {
              if (!errorString) return accErrors
              return {
                ...accErrors,
                [key]: errorString,
              }
            },
            {},
          )

          if (!isEmpty(fieldErrors)) {
            if (prefix) {
              // For nested fields, set the error in the nested structure
              setNestedError(errors, fullFieldName, fieldErrors)
            } else {
              // For top-level fields, set directly
              errors[fieldName] = fieldErrors
            }
          }
        }

        // If the value is an object (and not an array), recursively process its properties
        if (
          val &&
          typeof val === 'object' &&
          !Array.isArray(val) &&
          val.constructor === Object
        ) {
          processFields(val, fullFieldName)
        }
      })
    }

    // Process all fields starting from the root
    processFields(values)

    return errors
  }
}
